import React from 'react';
import { motion } from 'framer-motion';


const DEFAULT_ROW_COUNT = 3;
const DEFAULT_COLUMN_COUNT = 2;

export interface TimeslotSkeletonProps {
	count?: number;
}

function getSkeletonItem(index: number) {
	return <li key={`skeleton-item-${index}`} className="h-[60px] w-full rounded-2xl bg-skeleton bg-[length:200%_100%] animate-shine"></li>;
}

export const TimeslotSkeleton = ({ count = (DEFAULT_COLUMN_COUNT * DEFAULT_ROW_COUNT) }: TimeslotSkeletonProps) => {

	const roundedCount = count % 2 ? count + 1 : count;
	const limitedCount = roundedCount > 6 ? 6 : roundedCount;
	return (
		<motion.ol
			className="w-full grid grid-cols-2 gap-3 mt-3"
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{(Array(limitedCount).fill(0).map((_, index) => getSkeletonItem(index)))}
		</motion.ol>
	);
};